export const environment = {
  production: true,
  apiUrl:  'https://casamichelrd.com/webapi'

  //'https://localhost:44338'
  //
}
